<div style="display:flex; align-items: center; flex-direction: column; margin-bottom: 30px;">
    <div class="headlines">Genomic Liftover</div>
    <form [formGroup]="ccsForm" (ngSubmit)="getDrugInfo()">
        <div class="form-group">
            <div class="textarea-div">
                <div style="display:flex; align-items: center;">
                    <div style="font-weight: bold;">Enter Sequence Data for Liftover.</div>
                    <mat-icon
                        matTooltip="Enter your sequence data in the format chrX:12345. For multiple conversion separate your inputs with a comma. E.g. 'chr1:10000,chr17:76737' or click 'Load Example' to get a basic example."
                        matTooltipPosition="right" style="transform: scale(0.8);">help</mat-icon>
                </div>
                <textarea class="form-control" id="inputName" formControlName="inputName"
                    placeholder="Enter Sequence Data, e.g. 'chr17:7673776' or click 'Load Example'"></textarea>
            </div>
            <div>
                <div>
                    <span>Target Genome (From)</span>
                    <div>
                        <div>
                            <input type="radio" id="hg19_f" name="referenceGenomeFrom" value="hg19"
                                formControlName="referenceGenomeFrom" />
                            <label for="hg19_f">HG19</label>
                        </div>
                        <div>
                            <input type="radio" id="hg38_f" name="referenceGenomeFrom" value="hg38"
                                formControlName="referenceGenomeFrom" />
                            <label for="hg38_f">HG38</label>
                        </div>
                        <div>
                            <input type="radio" id="t2t_f" name="referenceGenomeFrom" value="t2t"
                                formControlName="referenceGenomeFrom" />
                            <label for="t2t_f">T2T (hsa1)</label>
                        </div>
                    </div>
                </div>
                <div>
                    <span>Target Genome (To)</span>
                    <div>
                        <div>
                            <input type="radio" id="hg19_t" name="referenceGenomeTo" value="hg19"
                                formControlName="referenceGenomeTo" />
                            <label for="hg19_t">HG19</label>
                        </div>
                        <div>
                            <input type="radio" id="hg38_t" name="referenceGenomeTo" value="hg38"
                                formControlName="referenceGenomeTo" />
                            <label for="hg38_t">HG38</label>
                        </div>
                        <div>
                            <input type="radio" id="t2t_t" name="referenceGenomeTo" value="t2t"
                                formControlName="referenceGenomeTo" />
                            <label for="t2t_t">T2T (hsa1)</label>
                        </div>
                    </div>
                </div>
                <div>
                    <button type="button" class="btn btn-secondary" matTooltip="Info about the action"
                        matTooltipPosition="right" (click)="getExampleData()">Load Example</button><br>
                    <button type="submit" class="btn btn-primary" [disabled]="!ccsForm.valid">Submit</button>
                </div>
            </div>
        </div>
    </form>
</div>

<div *ngIf="complete_request!=''">
    <app-terminal-view [terminal_string]="complete_request"></app-terminal-view>
</div>

<div *ngIf="same_reference_genomes">
    <div style="color:red; font-weight: bold;">Please select different reference genomes for 'From' and 'To'.</div>
</div>

<div class="card-grid" *ngIf="reqObj != null">
    <div class="card" *ngFor="let element of reqObj.data">
        <div class="card-header">
            <h2>{{element.name}}</h2>
        </div>
        <ul *ngIf="element['response']==200">
            <li>New Position: {{element['new_position']}}</li>
            <li>Chromosome: {{element['chromosome']}}</li>
            <li>Strand: {{element['strand']}}</li>
            <!-- <li *ngFor="let item of element | keyvalue">{{item.key}}: {{item.value}}</li> -->
        </ul>
        <ul *ngIf="element['response']==400">
            <li style="color:red;">Error: {{element['error']}}</li>
            <!-- <li *ngFor="let item of element | keyvalue">{{item.key}}: {{item.value}}</li> -->
        </ul>
    </div>
</div>